import { Eye, Pencil, Shield } from "lucide-react";
import { Member } from "@/types";

export const mockApiKeys = [
  { id: "1", name: "Production API Key", key: "sk_live_••••••••7f3a", created: "Jan 15, 2026", lastUsed: "2 min ago", status: "active" },
  { id: "2", name: "Staging API Key", key: "sk_test_••••••••b2c1", created: "Feb 3, 2026", lastUsed: "1 week ago", status: "active" },
  { id: "3", name: "Old Integration Key", key: "sk_live_••••••••9e4d", created: "Nov 8, 2025", lastUsed: "3 months ago", status: "revoked" },
];

export const mockIntegrations = [
  { id: "1", name: "Amazon Advertising", status: "connected", icon: "📦", description: "Sync ad performance and keyword data" },
  { id: "2", name: "Google Analytics", status: "connected", icon: "📊", description: "Track traffic and conversion metrics" },
  { id: "3", name: "Slack", status: "disconnected", icon: "💬", description: "Get real-time alerts and notifications" },
  { id: "4", name: "Webhook", status: "connected", icon: "🔗", description: "Send events to external endpoints" },
];

export const roleConfig: Record<string, { label: string; color: string; icon: typeof Shield }> = {
  owner: { label: "Owner", color: "bg-primary/20 text-foreground border-primary/30 font-semibold", icon: Shield },
  admin: { label: "Admin", color: "bg-[hsl(185,70%,45%)]/20 text-foreground border-[hsl(185,70%,45%)]/30 font-semibold", icon: Shield },
  editor: { label: "Editor", color: "bg-[hsl(330,70%,55%)]/20 text-foreground border-[hsl(330,70%,55%)]/30 font-semibold", icon: Pencil },
  viewer: { label: "Viewer", color: "bg-muted text-foreground border-muted font-semibold", icon: Eye },
};

export function getMemberDisplayName(member: Member): string {
  if (member.first_name || member.last_name) {
    return `${member.first_name ?? ''} ${member.last_name ?? ''}`.trim();
  }
  return member.email;
}

export function getMemberInitials(member: Member): string {
  if (member.first_name && member.last_name) {
    return `${member.first_name[0]}${member.last_name[0]}`.toUpperCase();
  }
  if (member.first_name) {
    return member.first_name.slice(0, 2).toUpperCase();
  }
  return member.email.slice(0, 2).toUpperCase();
}

export function getAssignedUserDisplayName(user: { first_name: string | null; last_name: string | null; email: string }): string {
  const raw = (user.first_name || user.last_name)
    ? `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim()
    : user.email;
  return raw.length > 50 ? `${raw.slice(0, 50)}…` : raw;
}
